// extracted by mini-css-extract-plugin
export default {"loader":"LoaderSpinner_loader__7p0gl","spin":"LoaderSpinner_spin__6Xuxy"};